import http from '@/utils/http';

/**
 * 获取体检类型
 */
export const getTimeType = () => {
    return http({
        url: '/api/area/v2/checkup/time',
        method: 'get'
    });
};




